import { useCallback, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useLocation } from "react-use";

export function useHangfireCookiesCleaner() {
  const [, , removeCookie] = useCookies([
    "Authorization",
    "Ccau-Authorization",
  ]);
  const location = useLocation();

  const removeCookies = useCallback(() => {
    removeCookie("Authorization");
    removeCookie("Ccau-Authorization");
  }, [removeCookie]);

  useEffect(() => {
    removeCookies();
    window.addEventListener("beforeunload", removeCookies);
    document.addEventListener("visibilitychange", removeCookies);
    window.addEventListener("blur", removeCookies);
    return () => {
      removeCookies();
      window.removeEventListener("beforeunload", removeCookies);
      document.removeEventListener("visibilitychange", removeCookies);
      window.removeEventListener("blur", removeCookies);
    };
  }, [removeCookies, location]);

  return removeCookies;
}
